import React from "react";
import { useQuery } from "@apollo/react-hooks";

//components
import PageMeta from "core/PageMeta";
import LoadingSpinner from "core/LoadingSpinner";
import NotFound from "core/NotFound";
import IconDetailLayout from "icons/IconDetailLayout";
import IconDetailSteps from "icons/IconDetailSteps";

// queries
import { GET_ICON_DETAIL_PAGE_DATA } from "icons/queries";

// helpers
import { getTagsData } from "core/TagToggle/helpers";
import { getMoreFromThisIconCollection, getFormattedDate } from "./helpers";

import { IconEditorProvider } from "js/contexts/IconEditorContext";

const IconDetailPage = ({ match }) => {
    const { slugWithId } = match.params;

    const iconId = slugWithId.split("-").pop();

    const { loading, data } = useQuery(GET_ICON_DETAIL_PAGE_DATA, {
        fetchPolicy: "cache-and-network",
        skip: !iconId,
        variables: {
            iconId
        }
    });

    if (loading) {
        return <LoadingSpinner />;
    }

    const isNotFoundIconDetails = (!data || !data.iconDetail) && !loading;

    const { iconDetail, moreLikeThisIcon, currentUser } = data || {};

    const moreLikeThis = getMoreFromThisIconCollection({ moreLikeThisIcon });

    const tags = getTagsData({
        tags: iconDetail.tags,
        tagPath: "",
        tagPathReplace: ":tag",
        type: "icons"
    });

    const formattedCreatedAt = getFormattedDate({ iconDetail });

    return isNotFoundIconDetails ? (
        <NotFound />
    ) : (
        <IconEditorProvider iconId={iconDetail.id}>
            {iconDetail && (
                <PageMeta
                    title={`${iconDetail.title} Icon - Download ${iconDetail.title} Icon ${iconDetail.id} | Noun Project`}
                    removeDescriptionTag
                    useSocialMediaTags
                    previewImg={iconDetail.thumbnail}
                    previewImgAlt={`${iconDetail.title} icon`}
                    socialMediaDescription={`Love this icon by ${iconDetail.creator.name} from @NounProject`}
                    description={`${iconDetail.title} icon by ${iconDetail.creator.name}. Download this SVG and PNG ${iconDetail.title} icon today. Browse free icons or unlimited royalty-free icons with NounPro.`}
                >
                    <meta
                        name="description"
                        content={`${iconDetail.title} icon by ${iconDetail.creator.name}. Download this SVG and PNG ${iconDetail.title} icon today. Browse free icons or unlimited royalty-free icons with NounPro.`}
                    />
                </PageMeta>
            )}

            <IconDetailLayout
                heroRightColumnContent={
                    <IconDetailSteps
                        icon={iconDetail}
                        userIsLoggedIn={!!currentUser}
                        userHasSubscription={
                            !!currentUser && currentUser.hasSubscription
                        }
                        userHasPrepaidBalance={
                            !!currentUser && currentUser.hasPrepaidBalance
                        }
                    />
                }
                icon={iconDetail}
                moreLikeThisIcon={moreLikeThis}
                tags={tags}
                createdAt={formattedCreatedAt}
                userHasSubscription={currentUser && currentUser.hasSubscription}
                ownedTeams={currentUser && currentUser.ownedTeams}
                username={currentUser && currentUser.username}
            />
        </IconEditorProvider>
    );
};

export default IconDetailPage;
